<template>
    <div class="flex-container">
        <router-link to="/" class="pa-big">SIGN OUT FOR THE CUBES</router-link>
    </div>
</template>

<script>
export default {
    data() {
        return {

        };
    }
}
</script>

<style scoped>
a {
    display: block;
    text-align: center;
    flex-grow: 1;
    font-size: 4vw;
}
</style>



// WEBPACK FOOTER //
// src/components/SignOut.vue